import React from 'react';
import Button from './Button.js';

const BannerText = ({ title, subtitle, description, buttonLabel, buttonDestination }) => {
    return (
        <div className="w-full h-screen flex justify-center items-end py-6 px-4 sm:px-8 md:px-16">
            <div className="w-full lg:w-3/4 px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl bg-black bg-opacity-70 shadow-lg">
                <div className="space-y-4 text-left">
                    {title && (
                        <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-primary font-bold">
                            {title}
                        </h1>
                    )}
                    {subtitle && (
                        <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-secondary-light font-semibold">
                            {subtitle}
                        </h2>
                    )}
                    {description && (
                        <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-secondary-light font-medium">
                            {description}
                        </p>
                    )}
                    {buttonLabel && (
                        <div className="flex flex-wrap gap-4 mt-6">
                            <Button label={buttonLabel} destination={buttonDestination} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BannerText;